export function getAirportCode(value) {
  if (value) {
    if (value.Code) {
      return value.Code;
    }
    let result = '';
    let splittedText = '';

    if (value.indexOf('[') != -1) {
      splittedText = value.split('[');
      result = splittedText[1];
    } else {
      result = value;
    }

    result = result.replace(']', '');
    return result;
  }
  return '';
}

export function stripAirportCode(value) {
  if (value) {
    let result = '';
    let splittedText = '';

    if (value.indexOf('[') != -1) {
      splittedText = value.split('[');
      result = splittedText[0];
    } else {
      result = value;
    }

    result = result.replace(']', '');
    return result;
  }
  return '';
}
